import ENTIDADES from '@/graphql/querys/administracion/catalogos/entidades/entidades.gql';
import MUNICIPIOS_POR_ENTIDAD from '@/graphql/querys/administracion/catalogos/municipios/municipiosPorEntitad.gql';
import MUNICIPIOS from '@/graphql/querys/administracion/catalogos/municipios/municipios.gql';
import CATALOGO_INFRAESTRUCTURA_TIPOS from '@/graphql/querys/administracion/catalogos/infraestructurastipos/catalogoInfraestructuraTipos.gql';
import CATALOGO_INFRAESTRUCTURA_SUBTIPOS_POR_TIPO from '@/graphql/querys/administracion/catalogos/infraestructurasubtipos/catalogoInfraestructuraSubtiposPorTipo.gql';
import INFRAESTRUCTURAS from '@/graphql/querys/administracion/infraestructuras/infraestructuras.gql';
import AGREGAR_INFRAESTRUCTURA from '@/graphql/mutations/administracion/infraestructura/agregarInfraestructura.gql';
import ACTUALIZAR_INFRAESTRUCTURA from '@/graphql/mutations/administracion/infraestructura/actualizarInfraestructura.gql';
import REMOVER_INFRAESTRUCTURA from '@/graphql/mutations/administracion/infraestructura/removerInfraestructura.gql';

export default {
  apollo: {
    entidades: {
      query: ENTIDADES,
    },
    municipiosPorEntitad: {
      query: MUNICIPIOS_POR_ENTIDAD,
      variables() {
        return {
          idEntidad: this.infraestructura?.idEntidad ? this.infraestructura.idEntidad : '',
        };
      },
    },
    municipios: {
      query: MUNICIPIOS,
    },
    catalogoInfraestructuraTipos: {
      query: CATALOGO_INFRAESTRUCTURA_TIPOS,
    },
    catalogoInfraestructuraSubtiposPorTipo: {
      query: CATALOGO_INFRAESTRUCTURA_SUBTIPOS_POR_TIPO,
      variables() {
        return {
          idTipoInfraestructura: this.infraestructura?.idTipoInfraestructura ? this.infraestructura.idTipoInfraestructura : '',
        };
      },
    },
  },
  methods: {
    // Agregar Infraestrucutra
    async mixAgregarInfraestructura() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      // Agregar las ubicaciones
      this.infraestructura.ubicacionGeografica = JSON.stringify(this.puntosUbicacion);

      await this.$apollo
        .mutate({
          mutation: AGREGAR_INFRAESTRUCTURA,
          variables: {
            infraestructura: this.infraestructura,
          },
          update: (store, { data: { agregarInfraestructura } }) => {
            const query = {
              query: INFRAESTRUCTURAS,
            };
            const { infraestructuras } = store.readQuery(query);
            const infraestructurasCopia = infraestructuras.slice();
            infraestructurasCopia.push(agregarInfraestructura);
            store.writeQuery({
              ...query,
              data: {
                infraestructuras: infraestructurasCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Editar Tipo Infraesatructura
    async mixActualizarInfraestructura() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      // Agregar las ubicaciones
      this.infraestructura.ubicacionGeografica = JSON.stringify(this.puntosUbicacion);

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_INFRAESTRUCTURA,
          variables: {
            id: this.infraestructuraEditar.id,
            infraestructura: this.infraestructura,
          },
          update: (store, { data: { actualizarInfraestructura } }) => {
            const query = {
              query: INFRAESTRUCTURAS,
            };
            const data = store.readQuery(query);
            const { infraestructuras } = data;
            const index = infraestructuras
              .findIndex((infraestructura) => infraestructura.id
              === actualizarInfraestructura.id);
            if (index !== -1) {
              infraestructuras.splice(index, 1, actualizarInfraestructura);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar Infraestrucutra
    async mixEliminarInfraestructura() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_INFRAESTRUCTURA,
        variables: {
          id: this.infraestructuraEliminar.id,
        },
        update: (store) => {
          const query = {
            query: INFRAESTRUCTURAS,
          };
          const data = store.readQuery(query);
          const { infraestructuras } = data;
          const index = infraestructuras
            .findIndex((infraestructura) => infraestructura.id
            === this.infraestructuraEliminar.id);
          if (index !== -1) {
            infraestructuras.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
  computed: {
    mixGetEntidades() {
      if (!this.entidades) return [];
      return this.entidades;
    },
    mixGetMunicipios() {
      if (!this.municipiosPorEntitad) return [];
      return this.municipiosPorEntitad;
    },
    mixGetCatalogoInfraestructuraTipos() {
      if (!this.catalogoInfraestructuraTipos) return [];
      return this.catalogoInfraestructuraTipos;
    },
    mixGetCatalogoInfraestructuraSubtipos() {
      if (!this.catalogoInfraestructuraSubtiposPorTipo) return [];
      return this.catalogoInfraestructuraSubtiposPorTipo;
    },
  },
};
